import React, { FC, lazy } from 'react';

import { Route } from 'react-router-dom';

import EAppRoute from '@/types/appRoutes';

const MainFormFlowLazy = lazy(() =>
	import('@/modules').then((module) => ({ default: module.MainFormFlow })),
);
const BusinessAcquisitionFormFlowLazy = lazy(() =>
	import('@/modules').then((module) => ({ default: module.BusinessAcquisitionFormFlow })),
);
const BankStatementsFormFlowLazy = lazy(() =>
	import('@/modules').then((module) => ({ default: module.BankStatementsFormFlow })),
);

const DebtsFormPageLazy = lazy(() =>
	import('@/pages').then((module) => ({ default: module.DebtsFormPage })),
);
const FormPageLazy = lazy(() => import('@/pages').then((module) => ({ default: module.FormPage })));

interface IFormFlowRoutesProps {
	withoutPartnerSlug?: boolean;
}

export const FormFlowRoutes: FC<IFormFlowRoutesProps> = ({ withoutPartnerSlug }) => {
	const getRoutePath = (path: string): string => {
		if (withoutPartnerSlug) {
			return path.replace(EAppRoute.Partner, '');
		}

		return path;
	};

	return (
		<React.Fragment>
			<Route element={<FormPageLazy />} path={getRoutePath(EAppRoute.Partner)}>
				<Route element={<MainFormFlowLazy />} index />
				<Route
					element={<BusinessAcquisitionFormFlowLazy />}
					path={getRoutePath(EAppRoute.BusinessAcquisition)}
				/>
				<Route
					element={<BankStatementsFormFlowLazy />}
					path={getRoutePath(EAppRoute.BankStatements)}
				/>
			</Route>
			<Route element={<DebtsFormPageLazy />} path={getRoutePath(EAppRoute.Debts)} />
		</React.Fragment>
	);
};
